import { Carousel as DSCarousel } from '@redbubble/design-system';
import { AppProps } from '@redbubble/next/types';
import { usePageProps } from '@redbubble/next-provider';
import React from 'react';
import { useResponsiveCarouselConfig } from './useResponsiveCarouselConfig';

export const Carousel = ({
  children,
  itemsInView,
}: {
  children: React.ReactNode;
  itemsInView?: {
    mobile: number;
    tablet: number;
    desktop: number;
  };
}) => {
  const { deviceType } = usePageProps<AppProps>();

  const { recommendedProfile, recommendedItemsInView } =
    useResponsiveCarouselConfig(deviceType, itemsInView);

  return (
    <DSCarousel
      profile={recommendedProfile}
      slidesPerView={recommendedItemsInView}
    >
      {children}
    </DSCarousel>
  );
};
